import { useParams } from "react-router-dom";
import { Loader } from "@themes/pollinator/ui/Loader";
import { Type } from "@themes/pollinator/ui/Type";
import { OuterContentContainer } from "@themes/pollinator/ui/OuterContentContainer";
import { OnboardingContent } from "@platform/features/onboarding";
import { useOnboardingPage } from "@platform/hooks/useOnboardingPage";

export function OrgAdminOnboardingPage() {
  const { id, orgId } = useParams<{ id: string; orgId: string }>();
  const programId = id ? Number(id) : undefined;

  const {
    isLoading,
    steps,
    currentStep,
    effectiveStepIndex,
    isLastStep,
    canSkip,
    stepStates,
    onStepComplete,
    onSkipClick,
    onStepClick,
    onBackClick,
    quizQuestionIndex,
    onQuizQuestionIndexChange,
  } = useOnboardingPage({
    programId,
    flowType: "orgAdmin",
    completionPath: `/program/${programId}/organization/${orgId}/admin/outreach`,
  });

  if (isLoading) {
    return <Loader isFullPage />;
  }

  if (!programId || steps.length === 0) {
    return (
      <OuterContentContainer className="flex flex-1" innerClassName="gap-8">
        <div className="flex flex-col flex-1 items-center justify-center">
          <Type variant="body1" className="text-brand-600">
            No onboarding steps found.
          </Type>
        </div>
      </OuterContentContainer>
    );
  }

  if (!currentStep) {
    return <Loader isFullPage />;
  }

  return (
    <OnboardingContent
      programId={programId}
      currentStep={currentStep}
      effectiveStepIndex={effectiveStepIndex}
      steps={steps}
      isLastStep={isLastStep}
      canSkip={canSkip}
      stepStates={stepStates}
      onStepComplete={onStepComplete}
      onSkipClick={onSkipClick}
      onStepClick={onStepClick}
      onBackClick={onBackClick}
      quizQuestionIndex={quizQuestionIndex}
      onQuizQuestionIndexChange={onQuizQuestionIndexChange}
    />
  );
}

export default OrgAdminOnboardingPage;
